<template>
    <div id="nav">
        <router-link to="/">All</router-link> |
        <router-link to="/crimes">Crimes</router-link> | 
        <router-link to="/gym">Gym</router-link> | 
        <router-link to="/players">Players</router-link> | 
        <router-link to="/items">Items</router-link> 
        <div style="flex: 1"></div>
        <input v-model="new_key" :placeholder="auth_key || 'API KEY'"/>

    </div>

    <div id="sub-nav">
        
    </div>
    <div id="filter-bar">
        <select v-model="color_filter">
            <option :value="null">All Colours</option>
            <option value="green">Green</option>
            <option value="red">Red</option>
            <option value="none">None</option>
        </select>
        <select v-model="category_filter">
            <option :value="null">All Categories</option>
            <option v-for="category in options.categories" :key="`option-category-${category}`" :value="category">{{category}}</option>
        </select>
        <select v-model="log_type_filter">
            <option :value="null">All Log Types</option>
            <option v-for="log_type in log_types" :key="`option-log-type-${log_type}`" :value="log_type">({{log_type.id}}) {{log_type.title}}</option>
        </select>
        <input type="date" v-model="date_start_filter"/>
        <input type="date" v-model="date_end_filter"/>
        <input type="text" v-model="player_id_filter" placeholder="player ID"/>
 
        <svg v-if="logs_loading" id="loading-spinner" style="margin-left: auto; background: rgba(221, 221, 221, 0) none repeat scroll 0% 0%; display: block;" width="200px" height="200px" viewBox="0 0 80 80" preserveAspectRatio="xMidYMid">
            <circle cx="40" cy="40" r="32" stroke-width="2" stroke="#ffffff" stroke-dasharray="50.26548245743669 50.26548245743669" fill="none" stroke-linecap="square">
                <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" keyTimes="0;1" values="0 40 40;360 40 40"></animateTransform>
            </circle>
        </svg>
    </div>

    <div id="view-wrapper">
        <!-- <div id="spinner-wrapper" :class="{'loading': logs_loading}">
            <svg id="loading-spinner" style="margin: auto; background: rgba(221, 221, 221, 0) none repeat scroll 0% 0%; display: block;" width="200px" height="200px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                <path fill="none" stroke="#ffffff" stroke-width="1" stroke-dasharray="42.76482137044271 42.76482137044271" d="M24.3 30C11.4 30 5 43.3 5 50s6.4 20 19.3 20c19.3 0 32.1-40 51.4-40 C88.6 30 95 43.3 95 50s-6.4 20-19.3 20C56.4 70 43.6 30 24.3 30z" stroke-linecap="round" style="transform:scale(0.8);transform-origin:50px 50px">
                    <animate attributeName="stroke-dashoffset" repeatCount="indefinite" dur="2s" keyTimes="0;1" values="0;256.58892822265625"></animate>
                </path>
            </svg>
        </div> -->

        <router-view/>
    </div>
</template>

<script>
import {debounce} from 'lodash';
export default {
    data() {
        return {
            interval: null,
            options: {
                categories: null,
                log_types: null,
            },
            new_key: null
        }
    },

    mounted() {
        if (this.auth_key) {
            this.new_key = this.auth_key;
            if (!this.interval) {
                //  Fetch new logs each minute.
                this.interval = setInterval(() => {
                    if (  this.auth_key && this.sync_enabled ) {
                        this.$store.dispatch('fetchNewLogs', false);
                    }
                }, 60000);
            }
        }

        let last_item_sync = this.$store.state.sync.items_last_indexed;
        let now = new Date().getTime();
        let one_day = 1000*60*60; //*24 ; //*7;
        if (last_item_sync === null || last_item_sync < (now - one_day)) {
            console.log("[ui] updating items index")
            this.$store.dispatch('updateItemsIndex');
        } else {
            console.log("[ui] loading items")
            this.$store.dispatch('loadItemsIndex');
        }

        this.$store.dispatch('databaseExec', async (database) => {
            let all_entries = await database.log_entries.toArray();
            let temp_data = {
                categories: [],
                log_types: [],
            }
            let category_data = all_entries.reduce((entries, entry) => {
                let category = entry.category;
                let log_number = entry.log;
                let title = entry.title;
                
                if (!entries.categories.includes(category)) entries.categories.push(category);

                if (! entries.log_types.find(type => type.id === log_number)) entries.log_types.push({
                    id: log_number,
                    title,
                    category,
                });

                return entries;
            },temp_data);

            this.options.categories = category_data.categories.sort();
            this.options.log_types = category_data.log_types.sort((a, b) => a.id < b.id ? -1 : a.id > b.id ? 1 : 0 );

        });


    },

    computed: {
        auth_key() {
            return this.$store.state.auth.key;
        },

        players_referenced() {
            return this.$store.getters.referenced_players;
        },

        players() {
            return this.$store.state.players;
        },

        sync_enabled() {
            return this.$store.state.sync.enabled;
        },

     

        logs_loading() {
            return this.$store.state.loading.logs;
        },

        log_types() {
            if (!this.options.log_types) return null;
            let types = this.options.log_types;

            return this.filters.category ? types.filter(type => type.category === this.filters.category) : types;
        },

        filters() {
            return this.$store.state.filters;
        },

        color_filter: {
            get: function() {
                return this.filters.color;
            },
            
            set: function(value) {
                this.$store.commit('setFilter', {
                    filter: 'color',
                    value,
                });
            }
        },
        category_filter: {
            get: function() {
                return this.filters.category;
            },
            
            set: debounce(function(value) {
                this.$store.commit('setFilter', {
                    filter: 'category',
                    value,
                });
            }, 300)
        },
        log_type_filter: {
            get: function() {
                return this.filters.log_type;
            },
            
            set: debounce(function(value) {
                this.$store.commit('setFilter', {
                    filter: 'log_type',
                    value,
                });
            }, 300)
        },
        player_id_filter: {
            get: function() {
                return this.filters.player_id;
            },
            
            set: debounce(function(value) {
                this.$store.commit('setFilter', {
                    filter: 'player_id',
                    value: value ? parseInt(value) : null,
                });
            }, 300)
        },
        date_start_filter: {
            get: function() {
                return this.filters.date.start;
            },
            
            set: debounce(function(value) {
                this.$store.commit('setFilter', {
                    filter: 'date',
                    value: {
                        start: value,
                        end: this.filters.date.end,
                    },
                });
            }, 300)
        },
        date_end_filter: {
            get: function() {
                return this.filters.date.end;
            },
            
            set: debounce(function(value) {
                this.$store.commit('setFilter', {
                    filter: 'date',
                    value: {
                        start: this.filters.date.start,
                        end: value,
                    },
                });
            }, 300)
        },
    },

    watch: {
        players_referenced() {
            let ids_loaded = Object.keys(this.players);
            let not_loaded = this.players_referenced.filter(id => !ids_loaded.includes(id));
            if (not_loaded.length) this.$store.dispatch('getPlayers', not_loaded);
        },
        new_key(new_val) {
            if (new_val != this.auth_key) this.$store.commit('setAuthKey', new_val);
        }
    }
}
</script>
<style lang="scss">
@import '/style/app.scss';

#app {
	font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: left;
	color: #efefef;
    height: 100vh;
    background-color: black;
    
}

#nav {
    padding: 15px ;
	background-color: #2d2d2d;
    display: flex;
    flex-direction: row;
    align-items: center;
    a {
        font-weight: bold;
        color: #FAFAFA;

        &.router-link-exact-active  {
            color: #FAAF00;
        }
        margin-right: 10px;
        &:not(:first-child) {
            margin-left: 10px;
        }
    }

}

#filter-bar {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
    padding-left: 5px;
    background-color: #0f0f0f;
}

#sub-nav {
	background-color: #1d1d1d;
	display: flex;
    flex-wrap: wrap;
	align-items: center;
	padding: 0 7px;


	.sub-nav-item {
		margin: 8px 8px;
		&.selected {
			color: #FAAF00
		}
	}
}



#view-wrapper {
    position: relative;
}

#spinner-wrapper{
    display: none;
    background-color: #000B;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 100;
    
}
#spinner-wrapper.loading {
    display: block;
}
#loading-spinner {
    // width: 100%;
    height: 30px;
    width: auto;
}



</style>
